<template>
  <nav class="bg-white/80 backdrop-blur-md shadow-lg sticky top-0 z-50 transition-all duration-500 border-b border-white/20" :class="{ 'shadow-xl bg-white/90': isScrolled }">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between h-20">
            <div class="flex items-center">
              <router-link to="/" class="flex-shrink-0 flex items-center group">
                <!-- Logo moderne avec effet glassmorphism -->
                <div class="relative p-2 rounded-2xl bg-gradient-to-br from-white/20 to-white/10 backdrop-blur-sm border border-white/30 transition-all duration-500 group-hover:scale-110 group-hover:shadow-lg">
                  <img 
                    src="/src/assets/logo.png" 
                    alt="Logo Émulation Stavelot" 
                    class="object-contain transition-all duration-500 ease-out filter drop-shadow-lg"
                    :class="isScrolled ? 'h-8 w-8' : 'h-12 w-12'"
                  />
                  <!-- Effet de glow au hover -->
                  <div class="absolute inset-0 bg-gradient-to-br from-primary-400/20 to-gold-400/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-sm"></div>
                </div>
              </router-link>
            </div>
        
        <!-- Desktop menu -->
        <div class="hidden md:flex items-center space-x-2">
          <router-link 
            to="/" 
            class="nav-link group px-4 py-2 rounded-xl transition-all duration-300 hover:bg-white/20"
            :class="{ 'text-primary-600 bg-white/30': $route.name === 'Home' }"
          >
            Accueil
          </router-link>
          <router-link 
            to="/history" 
            class="nav-link group px-4 py-2 rounded-xl transition-all duration-300 hover:bg-white/20"
            :class="{ 'text-primary-600 bg-white/30': $route.name === 'History' }"
          >
            Historique
          </router-link>
          <router-link 
            to="/committee" 
            class="nav-link group px-4 py-2 rounded-xl transition-all duration-300 hover:bg-white/20"
            :class="{ 'text-primary-600 bg-white/30': $route.name === 'Committee' }"
          >
            Comité
          </router-link>
          <router-link 
            to="/performances" 
            class="nav-link group px-4 py-2 rounded-xl transition-all duration-300 hover:bg-white/20"
            :class="{ 'text-primary-600 bg-white/30': $route.name === 'Performances' }"
          >
            Agenda
          </router-link>
          <router-link 
            to="/news" 
            class="nav-link group px-4 py-2 rounded-xl transition-all duration-300 hover:bg-white/20"
            :class="{ 'text-primary-600 bg-white/30': $route.name === 'News' }"
          >
            Actualités
          </router-link>
          <router-link 
            to="/videos" 
            class="nav-link group px-4 py-2 rounded-xl transition-all duration-300 hover:bg-white/20"
            :class="{ 'text-primary-600 bg-white/30': $route.name === 'Videos' }"
          >
            Vidéos
          </router-link>
          <router-link 
            to="/sponsors" 
            class="nav-link group px-4 py-2 rounded-xl transition-all duration-300 hover:bg-white/20"
            :class="{ 'text-primary-600 bg-white/30': $route.name === 'Sponsors' }"
          >
            Partenaires
          </router-link>
          <router-link 
            to="/contact" 
            class="nav-link group px-4 py-2 rounded-xl transition-all duration-300 hover:bg-white/20"
            :class="{ 'text-primary-600 bg-white/30': $route.name === 'Contact' }"
          >
            Contact
          </router-link>
        </div>
        
        <!-- Mobile menu button -->
        <div class="md:hidden flex items-center">
          <button 
            @click="mobileMenuOpen = !mobileMenuOpen"
            class="relative p-3 rounded-xl bg-white/20 backdrop-blur-sm border border-white/30 hover:bg-white/30 transition-all duration-300 hover:scale-110"
          >
            <span class="sr-only">Ouvrir le menu</span>
            <div class="w-6 h-6 flex flex-col justify-center items-center">
              <span class="block w-5 h-0.5 bg-gray-700 transition-all duration-300" :class="mobileMenuOpen ? 'rotate-45 translate-y-1' : ''"></span>
              <span class="block w-5 h-0.5 bg-gray-700 transition-all duration-300 mt-1" :class="mobileMenuOpen ? 'opacity-0' : ''"></span>
              <span class="block w-5 h-0.5 bg-gray-700 transition-all duration-300 mt-1" :class="mobileMenuOpen ? '-rotate-45 -translate-y-1' : ''"></span>
            </div>
          </button>
        </div>
      </div>
    </div>
    
    <!-- Mobile menu -->
    <div v-show="mobileMenuOpen" class="md:hidden transition-all duration-500 ease-out">
      <div class="px-6 pt-6 pb-8 space-y-3 bg-white/95 backdrop-blur-xl border-t border-white/30 shadow-2xl">
        <router-link 
          to="/" 
          class="block px-4 py-3 rounded-xl text-base font-medium text-gray-700 hover:text-primary-600 hover:bg-white/50 transition-all duration-300 hover:scale-105"
          @click="mobileMenuOpen = false"
        >
          Accueil
        </router-link>
        <router-link 
          to="/history" 
          class="block px-4 py-3 rounded-xl text-base font-medium text-gray-700 hover:text-primary-600 hover:bg-white/50 transition-all duration-300 hover:scale-105"
          @click="mobileMenuOpen = false"
        >
          Historique
        </router-link>
        <router-link 
          to="/committee" 
          class="block px-4 py-3 rounded-xl text-base font-medium text-gray-700 hover:text-primary-600 hover:bg-white/50 transition-all duration-300 hover:scale-105"
          @click="mobileMenuOpen = false"
        >
          Comité
        </router-link>
        <router-link 
          to="/performances" 
          class="block px-4 py-3 rounded-xl text-base font-medium text-gray-700 hover:text-primary-600 hover:bg-white/50 transition-all duration-300 hover:scale-105"
          @click="mobileMenuOpen = false"
        >
          Agenda
        </router-link>
        <router-link 
          to="/news" 
          class="block px-4 py-3 rounded-xl text-base font-medium text-gray-700 hover:text-primary-600 hover:bg-white/50 transition-all duration-300 hover:scale-105"
          @click="mobileMenuOpen = false"
        >
          Actualités
        </router-link>
        <router-link 
          to="/videos" 
          class="block px-4 py-3 rounded-xl text-base font-medium text-gray-700 hover:text-primary-600 hover:bg-white/50 transition-all duration-300 hover:scale-105"
          @click="mobileMenuOpen = false"
        >
          Vidéos
        </router-link>
        <router-link 
          to="/sponsors" 
          class="block px-4 py-3 rounded-xl text-base font-medium text-gray-700 hover:text-primary-600 hover:bg-white/50 transition-all duration-300 hover:scale-105"
          @click="mobileMenuOpen = false"
        >
          Partenaires
        </router-link>
        <router-link 
          to="/contact" 
          class="block px-4 py-3 rounded-xl text-base font-medium text-gray-700 hover:text-primary-600 hover:bg-white/50 transition-all duration-300 hover:scale-105"
          @click="mobileMenuOpen = false"
        >
          Contact
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      mobileMenuOpen: false,
      isScrolled: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50
    }
  }
}
</script>
